import { useState } from "react";
import { tableData, tableHeader } from "../utils/style";
import downArrow from "../assets/icons/down_arrow.png";
import reset from "../assets/icons/reset_icon.png";

const Table = ({
  data,
  columns,
  onRowSelect,
  setFilterQuery,
  filterData,
  setFilterData,
}) => {
  const [filterInputs, setFilterInputs] = useState(filterData);
  const [activeFilter, setActiveFilter] = useState(null);

  const handleInputChange = (e, key) => {
    setFilterInputs((prev) => ({
      ...prev,
      [key]: e.target.value,
    }));
  };

  const applyFilter = () => {
    setFilterData({ ...filterInputs });
    setFilterQuery(
      Object.entries(filterInputs)
        .filter(([_, value]) => value.trim() !== "")
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .join("&")
    );
    setActiveFilter(null);
  };

  const resetFilter = (key) => {
    setFilterData((prev) => {
      const updatedFilters = { ...prev };
      delete updatedFilters[key];
      return updatedFilters;
    });

    setFilterInputs((prev) => {
      const updatedInputs = { ...prev };
      delete updatedInputs[key];
      return updatedInputs;
    });

    setFilterQuery((prev) => {
      const updatedQuery = prev
        ?.split("&")
        .filter((param) => !param.startsWith(`${key}=`))
        .join("&");

      return updatedQuery;
    });
    setActiveFilter(null);
  };

  return (
    <div className='overflow-hidden'>
      <div className='overflow-auto'>
        <table className='table-auto w-full'>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th
                  key={index}
                  className={`relative text-left ${tableHeader}`}
                  style={{ width: column.width || "auto" }}
                >
                  <div className='flex items-center gap-2'>
                    <span>{column.header}</span>
                    {column.isFilterEnable && (
                      <div className='flex items-center'>
                        <img
                          className='cursor-pointer transition-transform hover:scale-110'
                          src={downArrow}
                          height={10}
                          width={10}
                          onClick={() =>
                            setActiveFilter(
                              activeFilter === column.key ? null : column.key
                            )
                          }
                        />
                        <img
                          className='ml-2 cursor-pointer opacity-80 hover:opacity-100 transition-opacity'
                          src={reset}
                          height={10}
                          alt=''
                          width={10}
                          onClick={() => resetFilter(column.key)}
                        />
                      </div>
                    )}
                  </div>

                  {activeFilter === column.key && (
                    <div className='absolute top-10 left-4 z-10 bg-white p-3 rounded-md shadow-lg w-56 border border-gray-200'>
                      <input
                        name={column.key}
                        value={filterInputs[column.key] || ""}
                        className='w-full px-3 py-1 bg-customTwo rounded-lg outline-none border-gray-300'
                        // placeholder={column.header}
                        onChange={(e) => handleInputChange(e, column.key)}
                      />
                      <button
                        className='mt-2 w-full border border-customOne rounded-lg py-2 text-center text-xs text-customOne font-semibold cursor-pointer'
                        onClick={applyFilter}
                      >
                        Filter
                      </button>
                    </div>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={
                    row.selected
                      ? "bg-green-100 border-b border-gray-200"
                      : "border-b border-gray-200"
                  }
                  onClick={() => onRowSelect(rowIndex)}
                >
                  {columns.map((column, colIndex) => (
                    <td key={colIndex} className={tableData}>
                      {column.render ? (
                        column.render(row[column.key])
                      ) : column.type === "img" ? (
                        <img
                          src={row[column.key]}
                          alt={row[column.key]}
                          className='w-16 h-16 object-cover rounded-md border'
                        />
                      ) : (
                        row[column.key]?.toString()
                      )}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <div className='text-center mt-4 p-6 text-sm'> No Data Found</div>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;
